import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconExit: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props} fill="none">
      <path
        d="M15 4H5V18C5 19.1046 5.89543 20 7 20H15"
        stroke={props.fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15L20 12M20 12L17 9M20 12H10"
        stroke={props.fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default IconExit;
